<template>
    <ModalComponent
        :name="'editar-' + producto.id"
        title="Editar producto"
        v-on:close="() => close(false)"
    >
        <FormComponent
            :producto="producto"
            :products="products"
            :desactivar="producto.productoSeleccionado ? true : false"
            @terminado="editarProducto"
        />
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormComponent from "@/components/backend/eventos/sesiones/productos/FormComponent";

    export default {
        props: ['producto', 'products'],
        methods: {
            close(actualizar) {
                this.$emit('close', actualizar, 'editar-' + this.producto.id);
            },
            editarProducto() {
                this.$emit('terminado', this.producto);
            }
        },
        components: {
            ModalComponent, FormComponent
        }
    }
</script>
